import React, { useState, useEffect } from 'react';
import {
  Typography, Input, message, Table, Form, Select,
  AutoComplete, Card, Space, Alert, Tooltip,InputNumber
} from 'antd';
import propTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { decimalDigitFormatter, formatComma } from '../../utils/stringFormat';
import useDropdownItem from '../../hooks/useDropdownItem';
import { URL_LOG_WOOD, URL_SCALE_LARGE } from '../../constance/urls';
import useSearchItem from '../../hooks/useSeatchItem';
import useItemDetail from '../../hooks/useItemDetail';
import { Toast } from '../../utils/Toast';
import { defaultTruckTransactionDetail } from '../../constance/dataTypes';
import { Media } from "../../AppMedia";
import { Col, Row } from 'antd';
import { useDebounce } from 'use-debounce';
import '../../antd.css';
import useLogWoodEvaluationCalculation from '../../hooks/useLogWoodEvaluationCalculation';


const LogWoodPODetail = React.forwardRef((props, ref) => {
  const {
    truckTransaction,
    enableEdit,
    logWoodEvaluationData,
    active,
    setDetailLoading,
  } = props;

  const { t } = useTranslation();
  const [form] = Form.useForm();
  const watches = Form.useWatch([], form)
  const { TextArea } = Input;
  const { Text } = Typography;

  const tableRef = React.useRef();
  const [truckCompanySearchTxt, setTruckCompanySearchTxt] = React.useState("")
  const [truckProductSearchTxt, setTruckProductSearchTxt] = React.useState("")
  const [trucklicenseSearchTxt, setTrucklicenseSearchTxt] = React.useState("");
  const [debouncelicense] = useDebounce(trucklicenseSearchTxt, 500);
  const [debounceTruckCompany] = useDebounce(truckCompanySearchTxt, 500);
  const buyPrice = Form.useWatch("buy_price", form)
  const [productText] = useDebounce(truckProductSearchTxt, 500);
  const [_, forceUpdate] = useState(0);
  const truckCompanies = useSearchItem({ url: URL_SCALE_LARGE.TRUCK_COMPANY, description_render: 'name', title_render: 'code' });
  const truckProducts = useSearchItem({ url: URL_SCALE_LARGE.TRUCK_PRODUCT, description_render: 'name', title_render: 'code' });
  const trucks = useSearchItem({ url: URL_SCALE_LARGE.TRUCK, title_render: 'license_plate' });
  const truckTypes = useDropdownItem({ url: URL_SCALE_LARGE.TRUCK_TYPE });

  const transactionTypes = useDropdownItem({ url: URL_SCALE_LARGE.TRANSACTION_TYPE });
  const courtyards = useDropdownItem({ url: URL_LOG_WOOD.COURTYARD });
  const logWoodTypes = useDropdownItem({ url: URL_LOG_WOOD.LOG_WOOD_TYPE });
  const logWoodSpeciesChoices = useDropdownItem({ url: URL_LOG_WOOD.LOG_WOOD_SPECIES });
  const logWoodEvaluateLengths = useDropdownItem({ url: URL_LOG_WOOD.LOG_WOOD_EVALUATE_LENGTH });
  const cutWeightChoices = useDropdownItem({ url: URL_LOG_WOOD.CUT_WEIGHT });
  const logWoodEvaluateSizeChoices = useDropdownItem({ url: URL_LOG_WOOD.LOG_WOOD_EVALUATE_SIZE });
  const woodPlotChoices = useDropdownItem({ url: URL_LOG_WOOD.WOOD_PLOT });

  const truckTransactionDetail = useItemDetail({ url: URL_SCALE_LARGE.TRUCK_TRANSACTION, id: truckTransaction ? truckTransaction.id : null, manual: true });
  const logWoodEvaluationDataDetail = useItemDetail({ url: URL_LOG_WOOD.LOG_WOOD_EVALUATION_DATA, id: logWoodEvaluationData ? logWoodEvaluationData.id : null, manual: true });
  const truckDetail = useItemDetail({ url: URL_SCALE_LARGE.TRUCK, id: truckTransaction ? truckTransaction.truck : null, manual: true });
  const truckCompanyDetail = useItemDetail({ url: URL_SCALE_LARGE.TRUCK_COMPANY, id: truckTransaction ? truckTransaction.truck_company : null, manual: true, readOnly: true });
  const truckProductDetail = useItemDetail({ url: URL_SCALE_LARGE.TRUCK_PRODUCT, id: truckTransaction ? truckTransaction.truck_product : null, manual: true, readOnly: true });
  const cutWeightEvaluateDetail = useItemDetail({ url: URL_LOG_WOOD.CUT_WEIGHT_EVALUATE, manual: true, })
  const evaluateDiameterDetail = useItemDetail({ url: URL_LOG_WOOD.LOG_WOOD_EVALUATE_DIAMETER, manual: true, })
  const speciesEvaluateDetail = useItemDetail({ url: URL_LOG_WOOD.LOG_WOOD_SPECIES_EVALUATE, manual: true, })

  const [cutWeights, setCutWeights] = React.useState([]);
  const [evaluateDiameters, setEvaluateDiameters] = React.useState([]);
  const [speciesList, setSpeciesList] = React.useState([]);
  const [diameterTableValidationErrorMessages, setDiameterTableValidationErrorMessages] = React.useState(false);
  const [speciesTableValidationErrorMessages, setSpeciesTableValidationErrorMessages] = React.useState(false);
  
  const { net_weight, std_buy_price, cut_weight, buy_amount } = useLogWoodEvaluationCalculation({
    truckTransaction: watches,
    logWoodEvaluationData: {
      ...watches,
      log_wood_evaluate_diameter_list: evaluateDiameters,
      log_wood_cut_weight_evaluate_list: cutWeights,
    },
  });

  React.useEffect(() => { 
    form.setFieldValue('net_weight', net_weight)
  }, [net_weight])
  React.useEffect(() => { 
    form.setFieldValue('std_buy_price', std_buy_price)
  }, [std_buy_price])
  React.useEffect(() => { 
    form.setFieldValue('cut_weight', cut_weight)
  }, [cut_weight])
  React.useEffect(() => { 
    form.setFieldValue('buy_amount', buy_amount)
  }, [buy_amount])

  const getLengthRatio = (value) => {
    const total =
      Number(form.getFieldValue('length_meet_criteria') || 0) +
      Number(form.getFieldValue('length_under_criteria') || 0) +
      Number(form.getFieldValue('length_over_criteria') || 0);
    if (total === 0) {
      return '0%';
    }
    const ratio = (value / total) * 100;
    return isNaN(ratio) ? '0%' : `${ratio.toFixed(2)}%`;
  };


  React.useImperativeHandle(ref, () => ({
    async handleSaveDetail() {
      try {
        const formData = await form.validateFields();
        const data = {
          ...formData,
          in_date_time: truckTransaction.in_date_time,
          out_date_time: truckTransaction.out_date_time,
          truck_product: formData.product.id,
          in_weight: truckTransaction.in_weight,
          out_weight: truckTransaction.out_weight,
        }
        setDiameterTableValidationErrorMessages(null);
        setSpeciesTableValidationErrorMessages(null);

        const evaluateDiameterSumRatio = evaluateDiameters.reduce((pre, cur) => pre + Number(cur.percent || 0), 0);
        if (evaluateDiameterSumRatio !== 100) {
          let messages = `${t('error_messages.log_wood_po.evaluate_diameter_validation_error')} (${evaluateDiameterSumRatio}%)`;
          Toast.error(messages);
          setDiameterTableValidationErrorMessages(messages);
          return false;
        }

        const speciesEvaluateSumRatio = speciesList.reduce((pre, cur) => pre + Number(cur.percent || 0), 0);
        if (speciesEvaluateSumRatio !== 100) {
          let messages = `${t('error_messages.log_wood_po.species_evaluate_validation_error')} (${speciesEvaluateSumRatio}%)`;
          Toast.error(messages);
          setSpeciesTableValidationErrorMessages(messages);
          return false;
        }

        const isSaveTruckCompanySuccess = formData.truck_company_detail.code !== truckTransaction.truck_company
          ? await truckCompanyDetail.handleCreate(formData.truck_company_detail)
          : true;
        if (!isSaveTruckCompanySuccess) return false;

        const isSaveTruckProductSuccess = formData.product.id !== truckTransaction.truck_product
          ? await truckProductDetail.handleCreate(formData.product)
          : true;
        if (!isSaveTruckProductSuccess) return false;

        const isSaveTruckSuccess = formData.truck !== truckTransaction.truck
          ? await truckDetail.handleCreate(formData.truck_license_plate)
          : await truckDetail.handleSave(formData.truck_license_plate);
        if (!isSaveTruckSuccess) return false;

        const isSaveCutWeightSuccess = await cutWeightEvaluateDetail.handleListCreate({
          log_wood_evaluation_data: logWoodEvaluationData.id,
          data: cutWeights.filter(e => e.weight !== 0),
        });

        const isSaveLogWoodDiameterSuccess = await evaluateDiameterDetail.handleListCreate({
          log_wood_evaluation_data: logWoodEvaluationData.id,
          data: evaluateDiameters.filter(e => e.percent > 0),
        });

        const isSaveSpeciesEvaluateSuccess = await speciesEvaluateDetail.handleListCreate({
          log_wood_evaluation_data: logWoodEvaluationData.id,
          data: speciesList.filter(e => e.percent > 0),
        });

        const updatelogWoodEvaluationData = {
          ...formData.logWoodEvaluationData,
          courtyard: formData.courtyard,
          location_code: formData.location_code,
          log_wood_type: formData.log_wood_type,
          eval_length: formData.eval_length,
          wood_plot: formData.wood_plot,
          wood_quality: formData.wood_quality,
          return_wood: formData.return_wood,
          buy_price: formData.buy_price,
          cut_weight: formData.cut_weight,
          length_meet_criteria: formData.length_meet_criteria,
          length_under_criteria: formData.length_under_criteria,
          length_over_criteria: formData.length_over_criteria,
        }
        const isSaveLogWoodEvaluateDataSuccess = await logWoodEvaluationDataDetail.handleSave(updatelogWoodEvaluationData);
        if (!isSaveLogWoodEvaluateDataSuccess) return false;

        const isSaveTruckTransactionSuccess = await truckTransactionDetail.handleSave(data);
        if (!isSaveTruckTransactionSuccess) return false;

        return (
          isSaveTruckCompanySuccess &&
          isSaveTruckProductSuccess &&
          isSaveTruckSuccess &&
          isSaveTruckTransactionSuccess &&
          isSaveLogWoodEvaluateDataSuccess &&
          isSaveCutWeightSuccess &&
          isSaveLogWoodDiameterSuccess &&
          isSaveSpeciesEvaluateSuccess
        );
      } catch (error) {
        return false;
      }
    },
    detail: {
      truck_transaction: form.getFieldsValue,
      log_wood_evaluation_data: {
        ...form.getFieldValue,
        log_wood_evaluate_diameter_list: evaluateDiameters,
        log_wood_cut_weight_evaluate_list: cutWeights,
      },
    },
  }));


  useEffect(() => {
    form.setFieldsValue(logWoodEvaluationData);
  }, [logWoodEvaluationData, form]);


  React.useEffect(() => {
    setDetailLoading(
      truckCompanyDetail.isLoading ||
      truckProductDetail.isLoading ||
      truckDetail.isLoading ||
      truckTransactionDetail.isLoading ||
      cutWeightEvaluateDetail.isLoading ||
      evaluateDiameterDetail.isLoading ||
      logWoodEvaluationDataDetail.isLoading ||
      speciesEvaluateDetail.isLoading
    );
  }, [
    truckCompanyDetail.isLoading,
    truckProductDetail.isLoading,
    truckDetail.isLoading,
    truckTransactionDetail.isLoading,
    cutWeightEvaluateDetail.isLoading,
    evaluateDiameterDetail.isLoading,
    logWoodEvaluationDataDetail.isLoading,
    speciesEvaluateDetail.isLoading,
  ])

  useEffect(() => {
    if (cutWeightChoices.response && logWoodEvaluationData.id) {
      const updatedCutWeights = cutWeightChoices.response.map(choice => {
        const result = logWoodEvaluationData.log_wood_cut_weight_evaluate_list.find(
          cutWeight => cutWeight.choice === choice.id
        );
        return result
          ? {
            ...result,
            choice_name: choice.name,
            weight: decimalDigitFormatter(result.weight || 0),
            locked: choice.locked
          }
          : {
            choice: choice.id,
            choice_name: choice.name,
            weight: 0,
            locked: choice.locked,
          };
      });
      setCutWeights(updatedCutWeights);
    }

    if (logWoodEvaluateSizeChoices.response && logWoodEvaluationData.id) {
      const updatedEvaluateDiameters = logWoodEvaluateSizeChoices.response.map((choice) => {
        const result = logWoodEvaluationData.log_wood_evaluate_diameter_list.find(
          (evaluateDiameter) =>
            String(evaluateDiameter.name).localeCompare(String(choice.name)) === 0
        );
        return result
          ? {
            ...result,
            percent: decimalDigitFormatter(result.percent || 0),
            choice: choice.id,
            name: choice.name,
          }
          : {
            name: choice.name,
            choice: choice.id,
            percent: 0,
            trade_std: choice.trade_std,
            weight_std: choice.weight_std,
            cost_std: choice.cost_std,
            sell_price: choice.sell_price,
          };
      });
      setEvaluateDiameters(updatedEvaluateDiameters);
      setDiameterTableValidationErrorMessages('');
    }
    if (logWoodSpeciesChoices.response && logWoodEvaluationData.id) {
      const newSpeciesEvaluate = logWoodSpeciesChoices.response.map(choice => {
        const result = logWoodEvaluationData.log_wood_species_evaluate_list.find(
          speciesEvaluate => speciesEvaluate.choice === choice.id
        );
        return result
          ? {
            ...result,
            choice_name: choice.name,
            percent: decimalDigitFormatter(result.percent || 0),
          }
          : {
            choice: choice.id,
            choice_name: choice.name,
            percent: 0,
          };
      });
      setSpeciesList(newSpeciesEvaluate);
    }
  }, [
    cutWeightChoices.response,
    logWoodEvaluationData,
    logWoodEvaluateSizeChoices.response,
    logWoodSpeciesChoices.response,
  ]);


  React.useEffect(() => {
    if (productText) {
      truckProducts.fetchData({ search: productText })
    }
    else
      if (debounceTruckCompany) {
        truckCompanies.fetchData({ search: debounceTruckCompany });
      }
      else
        if (debouncelicense) {
          trucks.fetchData({ search: debouncelicense });
        }
  }, [productText, debounceTruckCompany, debouncelicense])


  useEffect(() => {
    if (truckTransaction) {
      truckDetail.fetchData(truckTransaction.truck);
      truckProductDetail.fetchData(truckTransaction.truck_product);
    }
  }, [truckTransaction]);


  useEffect(() => {
    if (logWoodEvaluationData && logWoodEvaluationData.id) {
      logWoodEvaluationDataDetail.fetchData(logWoodEvaluationData.id);
    }
  }, [logWoodEvaluationData]);

  useEffect(() => {
    if (truckTransaction?.truck_company_detail || defaultTruckTransactionDetail) {
      const formattedTransaction = truckTransaction || defaultTruckTransactionDetail;
      form.setFieldsValue({
        ...formattedTransaction,
        truck_company_name: formattedTransaction.truck_company && formattedTransaction.truck_company_name ?
          `[${formattedTransaction.truck_company}] - ${formattedTransaction.truck_company_name}` : '',
        product: truckProductDetail.response,
        truck_product: truckProductDetail?.response?.name,
        truck_license_plate: truckDetail.response,
        logWoodEvaluationData: logWoodEvaluationDataDetail.response,
        in_weight: Math.round(formattedTransaction.in_weight) ? Number((truckTransaction?.in_weight) || 0) : 0,
        out_weight: Math.round(formattedTransaction.out_weight) ? Number((truckTransaction?.out_weight) || 0) : 0,
        net_weight: Math.round(Number(formattedTransaction.net_weight)) ? (Number(truckTransaction?.net_weight) || 0) : 0,

        in_date_time: formattedTransaction.in_date_time
          ? new Date(formattedTransaction.in_date_time).toLocaleString('en-GB')
          : '',
        out_date_time: formattedTransaction.out_date_time
          ? new Date(formattedTransaction.out_date_time).toLocaleString('en-GB')
          : '',
      });
    }
  }, [truckTransaction, defaultTruckTransactionDetail, truckProductDetail.response, truckDetail.response, logWoodEvaluationDataDetail.response]);

  const formatter = (value) => {
    const [start, end] = `${value}`.split('.') || [];
    const v = `${start}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return `${end ? `${v}.${end.padEnd(2, "0")}` : `${v}.00`}`;
  };

  return (
    <div>
      <Card>
        {
          (
            truckTransactionDetail.errorMessages ||
            logWoodEvaluationDataDetail.errorMessages ||
            truckDetail.errorMessages ||
            truckCompanyDetail.errorMessages ||
            truckProductDetail.errorMessages ||
            cutWeightEvaluateDetail.errorMessages ||
            evaluateDiameterDetail.errorMessages ||
            speciesEvaluateDetail.errorMessages
          ) && (
            <Alert style={{ marginBottom: '1rem', textAlign: 'left' }}
              message={t('error') + '!'}
              description={
                <>
                  {truckTransactionDetail.errorMessages && (
                    <Text>{truckTransactionDetail.errorMessages}</Text>
                  )}
                  {logWoodEvaluationDataDetail.errorMessages && (
                    <Text>{logWoodEvaluationDataDetail.errorMessages}</Text>
                  )}
                  {truckDetail.errorMessages && <Text>{truckDetail.errorMessages}</Text>}
                  {truckCompanyDetail.errorMessages && (
                    <Text>{truckCompanyDetail.errorMessages}</Text>
                  )}
                  {truckProductDetail.errorMessages && (
                    <Text>{truckProductDetail.errorMessages}</Text>
                  )}
                  {cutWeightEvaluateDetail.errorMessages && (
                    <Text>{cutWeightEvaluateDetail.errorMessages}</Text>
                  )}
                  {evaluateDiameterDetail.errorMessages && (
                    <Text>{evaluateDiameterDetail.errorMessages}</Text>
                  )}
                  {speciesEvaluateDetail.errorMessages && (
                    <Text>{speciesEvaluateDetail.errorMessages}</Text>
                  )}
                </>
              }
              type="error"
              showIcon
            />
          )
        }
          <Form
            className="form-bold-label"
            form={form}
            layout="vertical"
            name="logWoodForm"
            style={{ display: active ? 'block' : 'none', textAlign: "left" }} 
          >
            <Row gutter={16}>
              <Col sm={24} md={8} lg={4} style={{ width: '100%' }} >
                <Form.Item label={t("truck_transactions.in_date_time")} name="in_date_time">
                  {form.getFieldValue('in_date_time')}
                </Form.Item>
              </Col>
              <Col sm={24} md={8} lg={4} style={{ width: '100%' }}>
                <Form.Item label={t("truck_transactions.out_date_time")} name="out_date_time">
                {form.getFieldValue('out_date_time')}
                </Form.Item>
              </Col>
              <Col sm={24} md={8} lg={4} style={{ width: '100%' }}>
                <Form.Item label={t("truck_transactions.ticket")}>
                  {form.getFieldValue('ticket2')}
                </Form.Item>
              </Col>

              <Col sm={24} md={12} lg={6} style={{ width: '100%' }}>
                <Form.Item
                  name="license_plate"
                  label={t("trucks.license_plate")}
                  rules={[
                    {
                      required: true, message: `${t('error_messages.validation.required')}`
                    }
                  ]}
                >
                  <AutoComplete
                    onSearch={(value) => {
                      if (!enableEdit) return;
                      setTrucklicenseSearchTxt(value)
                    }}
                    onSelect={(value, data) => {
                      form.setFieldsValue({
                        license_plate: data.license_plate,
                        truck_license_plate: data,
                        truck: data.id
                      });
                    }}
                    options={trucks.response.map((truck) => ({
                      ...truck,
                      value: truck.license_plate,
                      label: truck.license_plate
                    }))}
                    notFoundContent={trucklicenseSearchTxt ? t('no_data') : ''}
                  >
                    <Input.Search
                      placeholder={`${t('search')} ${t('trucks.license_plate')}...`}
                      loading={trucks.isLoading}
                      onFocus={(e) => {
                        if (!enableEdit) e.target.blur();
                      }}
                    />
                  </AutoComplete>
                </Form.Item>
                <Form.Item name={'truck_license_plate'} hidden />
                <Form.Item name={'truck'} hidden />
              </Col>

              <Col sm={24} md={12} lg={6} style={{ width: '100%' }}>
                <Form.Item
                  label={t("trucks.type")}
                  name="truck_type"
                  rules={[
                    {
                      required: true,
                      message: t("error_messages.validation.required"),
                    },
                  ]}
                >
                  <Select
                    showSearch={enableEdit ? true : false}
                    options={truckTypes.response}
                    filterOption={(input, option) =>
                      (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                    }
                    onChange={(value) => {
                      const truck = form.getFieldValue('truck_license_plate')
                      const updateTruck = { ...truck, type: value }
                      form.setFieldsValue({ truck_license_plate: updateTruck })
                    }}
                    open={enableEdit ? undefined : false}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={24}>
              <Col sm={24} md={12} lg={9} style={{ width: '100%' }} >
                <Form.Item name={'truck_company'} hidden />
                <Form.Item name={'truck_company_detail'} hidden />
                <Form.Item
                  label={t('truck_transactions.company')}
                  name={'truck_company_name'}
                  layout='vertical'
                  rules={[{ required: true, message: t('error_messages.validation.key_not_found') }]}
                >
                  <AutoComplete
                    options={truckCompanies.response.map(item => ({
                      ...item,
                      value: JSON.stringify(item),
                      label: (
                        <Space direction="vertical" size={1}>
                          <Typography.Text strong>{item.code}</Typography.Text>
                          <Typography.Text type="secondary">{item.name}</Typography.Text>
                        </Space>
                      ),
                    }))}
                    onSearch={(value) => {
                      if (!enableEdit) return;
                      setTruckCompanySearchTxt(value);
                    }}
                    onSelect={(value, data) => {
                      const selectedCompany = JSON.parse(value);
                      form.setFieldsValue({
                        truck_company_detail: selectedCompany,
                        truck_company: selectedCompany.code,
                        truck_company_name: `[${selectedCompany.code}] - ${selectedCompany.name}`,
                      });
                    }}
                    notFoundContent={truckCompanySearchTxt ? t('no_data') : ''}
                  >
                    <Input.Search
                      placeholder={`${t('search')} ${t('searchs.fields.code')} ${t('or')} ${t('searchs.fields.name')}...`}
                      loading={truckCompanies.isLoading}
                      onFocus={(e) => {
                        if (!enableEdit) e.target.blur();
                      }}
                    />
                  </AutoComplete>
                </Form.Item>
              </Col>

              <Col sm={24} md={12} lg={9} style={{ width: '100%' }}>
                <Form.Item name={'product'} hidden />
                <Form.Item
                  label={t("truck_transactions.product")}
                  name="truck_product"
                  rules={[{ required: true, message: t('error_messages.validation.key_not_found') }]}
                >
                  <AutoComplete
                    options={truckProducts.response.map(item => {
                      return {
                        ...item,
                        value: JSON.stringify(item),
                        label: (
                          <Space direction="vertical" size={1}>
                            <Typography.Text strong>{item.code}</Typography.Text>
                            <Typography.Text type="secondary" >{item.name}</Typography.Text>
                          </Space>
                        )
                      }
                    }
                    )}
                    onSearch={(value) => {
                      if (!enableEdit) return;
                      setTruckProductSearchTxt(value);
                    }}
                    onSelect={(value, data) => {
                      const selectedProduct = JSON.parse(value);
                      form.setFieldsValue({
                        truck_product: selectedProduct.name,
                        product: selectedProduct
                      });
                    }}
                    notFoundContent={truckProductSearchTxt ? t('no_data') : ''}
                  >
                    <Input.Search
                      placeholder={`${t('search')} ${t('searchs.fields.code')} ${t('or')} ${t('searchs.fields.name')}...`}
                      loading={truckProducts.isLoading}
                      onFocus={(e) => {
                        if (!enableEdit) e.target.blur();
                      }}
                    />
                  </AutoComplete>
                </Form.Item>
              </Col>

              <Col sm={24} md={12} lg={6} style={{ width: '100%' }}>
                <Form.Item
                  label={t('truck_transactions.type')}
                  name="transaction_type"
                  rules={[{ required: true, message: t('error_messages.validation.key_not_found') }]}
                >
                  <Select
                    options={transactionTypes.response}
                    open={enableEdit ? undefined : false}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={24}>
              <Col sm={24} md={12} lg={6} style={{ width: '100%' }} >
                <Form.Item
                  label={t('log_wood_evaluation_datas.courtyard')}
                  name="courtyard"
                  rules={[{ required: true, message: t('error_messages.validation.required') }]}
                >
                  <Select
                    options={courtyards.response.map((item) => ({
                      value: item.id,
                      label: item.name,
                    }))}
                    open={enableEdit ? undefined : false}
                  />
                </Form.Item>
              </Col>

              <Col sm={24} md={12} lg={6} style={{ width: '100%' }}>
                <Form.Item name={'logWoodEvaluationData'} hidden />
                <Form.Item
                  label={t('log_wood_evaluation_datas.location_code')}
                  name="location_code"
                  rules={[{ required: true, message: t('error_messages.validation.required') }]}
                >
                  <Input
                    readOnly={!enableEdit}
                    open={enableEdit ? undefined : false}
                  />
                </Form.Item>
              </Col>

              <Col sm={24} md={12} lg={6} style={{ width: '100%' }}>
                <Form.Item
                  label={t('log_wood_evaluation_datas.log_wood_type')}
                  name="log_wood_type"
                  rules={[{ required: true, message: t('error_messages.validation.key_not_found') }]}
                >
                  <Select
                    options={logWoodTypes.response.map(item => ({
                      value: item.id,
                      label: item.name,
                    }))}
                    readOnly
                    open={enableEdit ? undefined : false}
                  />
                </Form.Item>
              </Col>

              <Col sm={24} md={12} lg={6} style={{ width: '100%' }}>
                <Form.Item
                  label={t('log_wood_evaluation_datas.log_wood_length')}
                  name="eval_length"
                  rules={[{ required: true, message: t('error_messages.validation.key_not_found') }]}
                >
                  <Select
                    options={logWoodEvaluateLengths.response.map(item => ({
                      value: item.id,
                      label: item.name,
                    }))}
                    readOnly
                    open={enableEdit ? undefined : false}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={24}>
              <Col sm={24} md={12} lg={6} style={{ width: '100%' }} >
                <Form.Item
                  label={t('truck_transactions.in_weight')}
                  name="in_weight"
                >
                  {formatComma(form.getFieldValue('in_weight'))} {t('units.kilo_gram')}
                </Form.Item>
              </Col>

              <Col sm={24} md={12} lg={6} style={{ width: '100%' }}>
                <Form.Item
                  label={t('truck_transactions.out_weight')}
                  name="out_weight"
                >
                  {formatComma(form.getFieldValue('out_weight'))} {t('units.kilo_gram')}
                </Form.Item>
              </Col>

              <Col sm={24} md={12} lg={6} style={{ width: '100%' }}>
                <Form.Item
                  label={t('log_wood_evaluation_datas.cut_weight')}
                  name="cut_weight"
                >
                  {formatComma(form.getFieldValue('cut_weight'))} {t('units.kilo_gram')}
                </Form.Item>
              </Col>

              <Col sm={24} md={12} lg={6} style={{ width: '100%' }}>
                <Form.Item
                  label={t('truck_transactions.net_weight')}
                  name="net_weight"
                >
                  {formatComma(form.getFieldValue('net_weight'))} {t('units.kilo_gram')}
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={24}>
              <Col sm={24} md={12} lg={6} style={{ width: '100%' }} >
                <Form.Item label={t('log_wood_evaluation_datas.std_buy_price')}>
                  {formatComma(form.getFieldValue('std_buy_price'))}
                </Form.Item>
              </Col>

              <Col sm={24} md={12} lg={6} style={{ width: '100%' }} >
                <Form.Item
                  label={t('log_wood_evaluation_datas.buy_price')}
                  name="buy_price"
                  validateStatus={std_buy_price < buyPrice ? "error" : null}
                  help={std_buy_price < buyPrice ? "ราคาซื้อมากกว่า STD" : null}
                >
                  <InputNumber
                    readOnly={!enableEdit}
                    addonAfter={`${t('units.baht')}/${t('units.kilo_gram')}`}
                    formatter={formatter}
                    onBlur={(e) => {
                      const value = form.getFieldValue('buy_price');
                      if (!value || value == '') {
                        form.setFieldValue('buy_price', 0)
                      }
                       }}
                  />
                </Form.Item>
              </Col>

              <Col sm={24} md={12} lg={6} style={{ width: '100%' }}>
                <Form.Item
                  label={t('log_wood_evaluation_datas.buy_amount')}
                  name="buy_amount"
                >
                  <InputNumber
                    readOnly={!enableEdit}
                    addonAfter={`${t('units.baht')}/${t('units.kilo_gram')}`}
                    formatter={formatter}
                    onBlur={(e) => {
                      const value = form.getFieldValue('buy_amount');
                      if (!value || value == '') {
                        form.setFieldValue('buy_amount', 0)
                      }
                    }}
                  />
                </Form.Item>
              </Col>

              <Col sm={24} md={12} lg={6} style={{ width: '100%' }}>
                <Form.Item
                  label={t('log_wood_evaluation_datas.return_wood')}
                  name="return_wood"
                >
                  <Input
                    addonAfter={t('units.log_wood')}
                    onBlur={(e) => {
                      let value = form.getFieldValue('return_wood');
                      if (!value || value === '') {
                        form.setFieldValue('return_wood', 0);
                      } else {
                        const roundedValue = Math.round(parseFloat(value)); // ตัดค่าทศนิยมออก
                        form.setFieldsValue({ return_wood: roundedValue });
                      }
                    }}
                    readOnly={!enableEdit}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Form.Item
              label={t('log_wood_evaluation_datas.wood_quality')}
              name="wood_quality"
            >
              <TextArea
                readOnly
                placeholder={t('log_wood_evaluation_datas.wood_quality')}
              />
            </Form.Item>
            <Form.Item
              label={t('log_wood_evaluation_datas.wood_plot')}
              name="wood_plot"
            >
              <Select
                options={woodPlotChoices.response.map(item => ({
                  value: item.id,
                  label: item.name,
                }))}
                readOnly
                open={enableEdit ? undefined : false}
              />
            </Form.Item>

            {/* เกณฑ์ความยาวไม้ */}
            <Form.Item
              label={t('log_wood_evaluation_datas.wood_length_criteria')}
            >
              <Table
                bordered
                pagination={false}
                dataSource={[
                  {
                    key: '1',
                    label: `${t('log_wood_evaluation_datas.length_meet_criteria')}`,
                    fieldName: 'length_meet_criteria',
                  },
                  {
                    key: '2',
                    label: `${t('log_wood_evaluation_datas.length_under_criteria')}`,
                    fieldName: 'length_under_criteria',
                  },
                  {
                    key: '3',
                    label: `${t('log_wood_evaluation_datas.length_over_criteria')}`,
                    fieldName: 'length_over_criteria',
                  },
                ]}
                columns={[
                  {
                    title: '',
                    dataIndex: 'label',
                    align: 'center',
                  },
                  {
                    title: `${t('datas.amount')}`,
                    dataIndex: 'fieldName',
                    key: 'fieldName',
                    align: 'center',
                    render: (fieldName) => (
                      <Form.Item name={fieldName} noStyle>
                        <Input
                          readOnly={!enableEdit}
                          style={{ textAlign: 'center', width: 100 }}
                          onChange={(e) => {
                            forceUpdate((prev) => prev + 1);
                            form.setFieldsValue({ [fieldName]: decimalDigitFormatter(e.target.value, 0) });
                          }}
                          onBlur={(e) => {
                            const value = form.getFieldValue(fieldName);
                            if (!value || String(value).trim() === '') {
                              form.setFieldsValue({ [fieldName]: 0 });
                            }
                          }}
                        />
                      </Form.Item>
                    ),
                  },
                  {
                    title: `${t('datas.ratio')} (%)`,
                    key: 'ratio',
                    align: 'center',
                    render: (_, record) => {
                      const value = form.getFieldValue(record.fieldName) || 0;
                      return getLengthRatio(value);
                    },
                  },
                ]}
              />
            </Form.Item>

            {/* พันธุ์ไม้ */}
            <Form.Item
              label={
                <div>
                  <Tooltip
                    title={speciesTableValidationErrorMessages}
                    open={!!speciesTableValidationErrorMessages}
                    color="red"
                    placement="right"
                  >
                    <span style={{ color: speciesTableValidationErrorMessages ? 'red' : 'inherit' }}>
                      {t('log_wood_evaluation_datas.log_wood_specie')}
                    </span>
                  </Tooltip>
                </div>
              }
              style={{ marginTop: '3rem' }}
            >

              {/* Mobile*/}
              <Media at="sm">
                <Table
                  bordered
                  pagination={false}
                  size="middle"
                  dataSource={speciesList}
                  rowKey={(record, index) => index.toString()}
                  columns={[
                    {
                      title: '',
                      dataIndex: 'choice_name',
                      align: 'center',
                    },
                    {
                      title: `${t('datas.ratio')} (%)`,
                      dataIndex: 'percent',
                      key: 'percent',
                      align: 'center',
                      render: (text, record, index) => (
                        <Form.Item
                          name={`percent-${index}`}
                          initialValue={text}
                          style={{ margin: 0 }}
                        >
                          <Input
                            style={{ textAlign: 'center', width: 100 }}
                            defaultValue={text}
                            onChange={(e) => {
                              const newSpeciesList = [...speciesList];
                              const value = e.target.value ? e.target.value : 0;
                              newSpeciesList[index].percent = decimalDigitFormatter(value || 0);
                              setSpeciesList(newSpeciesList);
                            }}
                            onBlur={(e) => {
                              let newSpeciesList = [...speciesList];
                              if (!newSpeciesList[index].percent || isNaN(newSpeciesList[index].percent)) {
                                newSpeciesList[index].percent = 0;
                              }
                              const name = `percent-${index}`
                              form.setFieldsValue({ [name]: newSpeciesList[index].percent });
                            }}
                            readOnly={!enableEdit}
                          />
                        </Form.Item>
                      ),
                    },
                  ]}
                />
              </Media>

              {/* Desktop*/}
              <Media greaterThan="sm">
                <Row gutter={[16, 16]}>
                  {[0, 1].map((isSecondHalf) => (
                    <Col span={12} key={isSecondHalf}>
                      <Table
                        bordered
                        dataSource={
                          isSecondHalf
                            ? speciesList.slice(Math.ceil(speciesList.length / 2))
                            : speciesList.slice(0, Math.ceil(speciesList.length / 2))
                        }
                        pagination={false}
                        rowKey="choice"
                      >
                        <Table.Column
                          title=""
                          dataIndex="choice_name"
                          key="choice_name"
                          align='center'
                          // render={(text) => <span>{text}</span>}
                        />
                        <Table.Column
                          title={`${t('datas.ratio')} (%)`}
                          dataIndex="percent"
                          key="percent"
                          render={(text, record, index) => {
                            const actualIndex = isSecondHalf ? Math.ceil(speciesList.length / 2) + index : index;
                            return (
                              <Form.Item
                                name={`speciesList[${actualIndex}].percent`}
                                initialValue={text || 0}
                                style={{margin: 0}}
                              >
                                <Input
                                  style={{ textAlign: 'center', width: 100 }}
                                  value={text}
                                  onChange={(e) => {
                                    const newSpeciesList = [...speciesList];
                                    const value = e.target.value ? e.target.value : 0;
                                    newSpeciesList[actualIndex].percent = decimalDigitFormatter(value || 0, 2);
                                    setSpeciesList(newSpeciesList);
                                  }}
                                  onBlur={(e) => {
                                    let newSpeciesList = [...speciesList];
                                    if (!newSpeciesList[actualIndex].percent || isNaN(newSpeciesList[actualIndex].percent)) {
                                      newSpeciesList[actualIndex].percent = 0;
                                    }
                                    const name = `speciesList[${actualIndex}].percent`;
                                    form.setFieldsValue({ [name]: newSpeciesList[actualIndex].percent });
                                  }}
                                  readOnly={!enableEdit}
                                />
                              </Form.Item>
                            )
                          }}
                        />
                      </Table>
                    </Col>
                  ))}
                </Row>
              </Media>
            </Form.Item>

            {/* ขนาดไม้ */}
            <Form.Item
              label={
                <div>
                  <Tooltip
                    title={diameterTableValidationErrorMessages}
                    open={!!diameterTableValidationErrorMessages}
                    color="red"
                    placement="right"
                  >
                    <span style={{ color: diameterTableValidationErrorMessages ? 'red' : 'inherit' }}>
                      {t('log_wood_evaluation_datas.log_wood_diameter')}
                    </span>
                  </Tooltip>
                </div>
              }
              style={{ marginTop: '3rem' }}
            >

              {/* Mobile*/}
              <Media at="sm">
                <Table
                  dataSource={evaluateDiameters}
                  columns={[
                    {
                      title: '',
                      dataIndex: 'name',
                      key: 'name',
                    },
                    {
                      title: `${t('datas.ratio')} (%)`,
                      dataIndex: 'percent',
                      key: 'percent',
                      render: (text, record, index) => (
                        <Input
                          value={record.percent}
                          style={{ textAlign: 'center', width: 100 }}
                          onChange={(e) => {
                            let newEvaluateDiameters = [...evaluateDiameters];
                            newEvaluateDiameters[index].percent = e.target.value;
                            setEvaluateDiameters(newEvaluateDiameters);
                            setDiameterTableValidationErrorMessages('');
                          }}
                          onBlur={(e) => {
                            let newEvaluateDiameters = [...evaluateDiameters];
                            if (!newEvaluateDiameters[index].percent || isNaN(newEvaluateDiameters[index].percent)) {
                              newEvaluateDiameters[index].percent = 0;
                            }
                            else {
                              newEvaluateDiameters[index].percent = decimalDigitFormatter(e.target.value);
                            }
                            setEvaluateDiameters(newEvaluateDiameters);
                          }}
                          readOnly={!enableEdit}
                        />
                      ),
                    },
                  ]}
                  rowKey={(record, index) => index.toString()}
                  pagination={false}
                  bordered
                />
              </Media>

              {/* Desktop*/}
              <Media greaterThan="sm">
                <Table
                  scroll={{ x: 1000 }}
                  dataSource={[{ name: `${t('datas.ratio')} (%)` }]}
                  columns={[
                    {
                      title: '',
                      dataIndex: 'name',
                    },
                    ...evaluateDiameters.map((choice, index) => ({
                      title: choice.name,
                      dataIndex: `percent_${index}`,
                      render: () => (
                        <Input
                          value={choice.percent}
                          style={{ textAlign: 'center', width: 100 }}
                          onChange={(e) => {
                            let newEvaluateDiameters = [...evaluateDiameters];
                            newEvaluateDiameters[index].percent = e.target.value;
                            setEvaluateDiameters(newEvaluateDiameters);
                            setDiameterTableValidationErrorMessages(false);
                          }}
                          onBlur={(e) => {
                            let newEvaluateDiameters = [...evaluateDiameters];
                            if (!newEvaluateDiameters[index].percent || isNaN(newEvaluateDiameters[index].percent)) {
                              newEvaluateDiameters[index].percent = 0;
                            }
                            else {
                              newEvaluateDiameters[index].percent = decimalDigitFormatter(e.target.value);
                            }
                            setEvaluateDiameters(newEvaluateDiameters);
                          }}
                          readOnly={!enableEdit}
                        />
                      ),
                    })),
                  ]}
                  rowKey={(record, index) => index.toString()}
                  pagination={false}
                  bordered
                />
              </Media>
            </Form.Item>


            {/* น้ำหนักหัก */}
            <Form.Item
              label={t('log_wood_evaluation_datas.cut_weight')}
              style={{ marginTop: '3rem' }}
            >
              {/* Mobile*/}
              <Media at="sm">
                <Table
                  bordered
                  pagination={false}
                  size="middle"
                  columns={[
                    {
                      title: '',
                      dataIndex: 'name',
                      render: (text, record) => <span>{record.choice_name}</span>,
                    },
                    {
                      title: `${t('log_wood_evaluation_datas.cut_weight')} (${t('units.kilo_gram')})`,
                      dataIndex: 'weight',
                      render: (text, record, index) => (
                        <>
                          <Input
                            style={{ textAlign: 'center', width: 100 }}
                            disabled={record.locked}
                            value={record.choice_name === t('datas.total')
                              ? formatComma(cutWeights.reduce((prev, curr) => prev + Number(curr.weight || 0), 0))
                              : (record.weight)}
                            onChange={e => {
                              const newCutWeights = [...cutWeights];
                              newCutWeights[index].weight = e.target.value;
                              setCutWeights(newCutWeights);
                            }}
                            onBlur={(e) => {
                              const newCutWeights = [...cutWeights];
                              if (!cutWeights[index].weight || isNaN(cutWeights[index].weight)) {
                                newCutWeights[index].weight = 0;
                                setCutWeights(newCutWeights);
                              }
                              else {
                                newCutWeights[index].weight = decimalDigitFormatter(e.target.value);
                              }
                              setCutWeights(newCutWeights);
                            }}
                            readOnly={!enableEdit}
                          />
                        </>
                      ),
                    },
                  ]}
                  dataSource={[...cutWeights, { choice_name: t('datas.total'), weight: null }]}
                  rowKey="choice_name"
                />
              </Media>
              {/* Desktop*/}
              <Media greaterThan="sm">
                <Table
                  scroll={{ x: 1000 }}
                  bordered
                  pagination={false}
                  dataSource={[
                    {
                      key: '1',
                      label: `${t('log_wood_evaluation_datas.cut_weight')} (${t('units.kilo_gram')})`,
                      ...cutWeights.reduce((obj, item, index) => {
                        obj[`cutWeight${index + 1}`] = item.weight;
                        return obj;
                      }, {}),
                      total: cutWeights.reduce((sum, cutWeight) => sum + Number(cutWeight.weight || 0), 0),
                    },
                  ]}
                  columns={[
                    {
                      title: '',
                      dataIndex: 'label',
                      render: (text) => <span>{text}</span>,
                    },
                    ...cutWeightChoices.response.map((choice, index) => ({
                      title: choice.name,
                      dataIndex: `cutWeight${index + 1}`,
                      render: (value, record) => (
                        <Form.Item style={{ margin: 0 }}>
                          <Input
                            style={{ textAlign: 'center', width: 100 }}
                            disabled={choice.locked}
                            value={value}
                            onChange={(e) => {
                              const newCutWeights = [...cutWeights];
                              newCutWeights[index].weight = e.target.value;
                              setCutWeights(newCutWeights);
                            }}
                            onBlur={(e) => {
                              const newCutWeights = [...cutWeights];
                              if (!newCutWeights[index]?.weight || isNaN(newCutWeights[index]?.weight)) {
                                newCutWeights[index].weight = 0;
                                setCutWeights(newCutWeights);
                              }
                              else {
                                newCutWeights[index].weight = decimalDigitFormatter(e.target.value);
                              }
                              setCutWeights(newCutWeights);
                            }}
                            readOnly={!enableEdit}
                          />
                        </Form.Item>
                      ),
                    })),
                    {
                      title: t('datas.total'),
                      dataIndex: 'total',
                      minWidth: 200,
                      render: (total) => (
                        <Form.Item style={{ margin: 0 }}>
                          <Input
                            readOnly={!enableEdit}
                            style={{ textAlign: 'center', border: 'none' }}
                            value={formatComma(total)}
                          />
                        </Form.Item>
                      ),
                    },
                  ]}
                />
              </Media>
            </Form.Item>
          </Form>
        
      </Card>
    </div >
  );
}
);

export default LogWoodPODetail;

LogWoodPODetail.defaultProps = {
  truckTransaction: {},
  enableEdit: false,
  logWoodEvaluationData: {},
  active: false,
  setDetailLoading: () => null,
};

LogWoodPODetail.propTypes = {
  truckTransactionId: propTypes.object,
  enableEdit: propTypes.bool,
  logWoodEvaluationDatatruckTransactionId: propTypes.object,
  active: propTypes.bool,
  setDetailLoading: propTypes.func,
};
